/**
 * iurop-faq.js — FAQs con categorías filtrables (Atisse)
 *
 * Las pestañas (data-faq-tab) filtran los <details> por data-faq-category.
 * La primera categoría se selecciona al iniciar. Re-init en shopify:section:load.
 */
(function () {
  'use strict';

  var NL_FLAG = 'iurop:faq-nl-posted';

  function setupNewsletterModal(root) {
    var modal = root.querySelector('[data-faq-nl-modal]');
    if (!modal) return;

    function open() {
      modal.hidden = false;
      document.documentElement.classList.add('iurop-faq-modal-open');
      var input = modal.querySelector('.iurop-faq__nl-input');
      if (input) input.focus();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('iurop-faq-modal-open');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-faq-nl-open]')) { open(); return; }
      if (e.target.closest('[data-faq-nl-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // El form 'customer' recarga la página al enviar: se marca el envío y,
    // a la vuelta, si hay resultado (éxito o error) se reabre el modal para
    // enseñarlo (el flag evita confundirlo con el newsletter del footer).
    var form = modal.querySelector('[data-faq-nl-form]');
    if (form) {
      form.addEventListener('submit', function () {
        try { window.sessionStorage.setItem(NL_FLAG, '1'); } catch (_) {}
      });
    }
    var posted = false;
    try { posted = window.sessionStorage.getItem(NL_FLAG) === '1'; } catch (_) {}
    if (posted) {
      try { window.sessionStorage.removeItem(NL_FLAG); } catch (_) {}
      if (modal.querySelector('[data-faq-nl-result]')) open();
    }
  }

  function init(root) {
    if (root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    setupNewsletterModal(root);

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
    if (!tabs.length || !items.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var cat = tab.dataset.faqTab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var show = item.dataset.faqCategory === cat;
          item.hidden = !show;
          if (!show) item.open = false;
        });
      });
    });
    tabs[0].click();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-iurop-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-iurop-faq]').forEach(function (el) {
        el.dataset.faqInit = '';
      });
      initAll(e.target);
    }
  });
})();
